export default "__VITE_PUBLIC_ASSET__af457ab2__"